import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Contract.TransferToNewClient.IRequest;
type Params = Api.Core.Contract.TransferToNewClient.IParams;
type Response = Api.Core.Contract.TransferToNewClient.IResponse;
type Headers = Api.Core.Contract.TransferToNewClient.IHeaders;
const url = '/api/Sales/Contract/:contractId/TransferToNewClient';
export default async function contractTransferToNewClientApi(
  params: Params,
  body: Request
): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    url: createPathFromRoute(url, params, null),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
